import * as React from 'react';
import { useStyles, isNumber, isUndefined } from '@sravni/react-utils';
import modules_578c5184 from '../styles/Heading.module.less.js';

/** Helper function */
const convertSizeAdaptiveToClassNames = (size) => {
    if (isUndefined(size))
        return [];
    const breakpoints = Object.keys(size);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? size[breakpoint]
        : `${breakpoint}-${size[breakpoint]}`;
    return breakpoints.map((breakpoint) => `size-${createName(breakpoint)}`);
};
/**
 * @description The Heading component is used for all headings.
 *
 * @component
 * @example
 * ```jsx
 * <Heading level={2}>
 *   Heading
 * </Heading>
 * ```
 */
const Heading = React.forwardRef((props, ref) => {
    const { as, level, size, className, children, ...restProps } = props;
    const cx = useStyles(modules_578c5184);
    const sizeAdaptive = React.useMemo(() => (isNumber(size) ? { mobile: size } : size), [size]);
    const sizeBreakpoints = size ? convertSizeAdaptiveToClassNames(sizeAdaptive) : [];
    const classNames = cx(className, 'container', {
        [`level-${level}`]: level,
    }, ...sizeBreakpoints);
    return React.createElement(as || `h${level}`, {
        ref,
        className: classNames,
        ...restProps,
    }, children);
});
Heading.defaultProps = {
    level: 1,
};
Heading.displayName = 'Heading';

export { Heading };
//# sourceMappingURL=Heading.js.map
